<div class="tax-wrapper tax-rules-admin">
  <div class="hero card-glass">
    <div class="crumb">
      <a routerLink="/utilisateur/admin/dashboard" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour au dashboard administration</a>
      <span class="crumb-current">Fiscalité</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">SoftPay · Règles de taxe</p>
        <h1>Console fiscale</h1>
        <p class="lead">Créez, modifiez, désactivez et simulez vos règles en un seul endroit.</p>
        <div class="pill-row">
          <span class="pill">Règles: {{ rules?.length || 0 }}</span>
          <span class="pill" *ngIf="loading">Chargement…</span>
          <span class="pill pill-strong">Simulation express</span>
        </div>
      </div>
      <div class="hero-side">
        <div class="side-card">
          <p class="side-label">Nouvelle règle</p>
          <button class="btn btn-primary btn-pill" (click)="newRule()">Créer</button>
        </div>
        <div class="side-card">
          <p class="side-label">Synchroniser</p>
          <button class="btn btn-outline-light btn-pill" (click)="refresh()" [disabled]="loading">
            {{ loading ? 'Chargement...' : 'Rafraîchir' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card-grid">
    <article class="card-glass tile">
      <div class="tile-head">
        <div>
          <p class="eyebrow">Formulaire</p>
          <h3 class="text-light">Créer ou modifier</h3>
          <p class="text-soft">Ouvrir le panneau latéral pour gérer une règle.</p>
        </div>
        <span class="pill" *ngIf="selected">Sélection : {{ selected.id }}</span>
      </div>
      <div class="tile-actions">
        <button class="btn btn-primary btn-pill" data-bs-toggle="offcanvas" data-bs-target="#offcanvasCreate" (click)="newRule()">Ouvrir le formulaire</button>
      </div>
    </article>

    <article class="card-glass tile">
      <div class="tile-head">
        <div>
          <p class="eyebrow">Simulation</p>
          <h3 class="text-light">Simulation rapide</h3>
          <p class="text-soft">Calculez l'impact pour un montant donné.</p>
        </div>
      </div>
      <div class="tile-actions">
        <button class="btn btn-outline-light btn-pill" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSim">Ouvrir la simulation</button>
      </div>
      <pre class="sim-result" *ngIf="simResult">{{ simResult | json }}</pre>
    </article>
  </div>

  <div class="card-glass table-card">
    <div class="tile-head">
      <div>
        <p class="eyebrow">Catalogue</p>
        <h3 class="text-light">Règles existantes</h3>
      </div>
      <span *ngIf="loading" class="pill">Chargement...</span>
    </div>
    <div class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Pays</th>
            <th>Fournisseur</th>
            <th>Opération</th>
            <th>Catégorie</th>
            <th>Rate bps</th>
            <th>Fixe</th>
            <th>Actif</th>
            <th>Eff. du</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of rules">
            <td>{{ r.id }}</td>
            <td>{{ r.countryCode }}</td>
            <td>{{ r.provider }}</td>
            <td>{{ r.operationType }}</td>
            <td>{{ r.category }}</td>
            <td>{{ r.rateBps }}</td>
            <td>{{ r.fixedAmount }}</td>
            <td>
              <span class="badge" [class.badge--green]="r.isActive ?? r.active" [class.badge--red]="!(r.isActive ?? r.active)">
                {{ (r.isActive ?? r.active) ? 'Oui' : 'Non' }}
              </span>
            </td>
            <td>{{ r.effectiveFrom | date:'short' }}</td>
            <td class="actions">
              <button class="btn btn-ghost btn-pill" type="button" (click)="editRule(r)">Éditer</button>
              <button class="btn btn-ghost btn-pill danger" type="button" (click)="deactivate(r)">Désactiver</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Offcanvas création/édition -->
<div class="offcanvas offcanvas-start offcanvas-glass" tabindex="-1" id="offcanvasCreate" aria-labelledby="offcanvasCreateLabel">
  <div class="offcanvas-header">
    <div>
      <p class="eyebrow mb-1">Règle fiscale</p>
      <h5 class="mb-0" id="offcanvasCreateLabel">{{ selected ? 'Modifier une règle' : 'Créer une règle' }}</h5>
    </div>
    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <form [formGroup]="form" (ngSubmit)="save()" class="grid">
      <label>Code pays
        <input type="text" formControlName="countryCode" maxlength="3" />
      </label>
      <label>Fournisseur
        <select formControlName="provider">
          <option *ngFor="let p of providers" [value]="p">{{ p }}</option>
        </select>
      </label>
      <label>Type opération
        <select formControlName="operationType">
          <option *ngFor="let op of operations" [value]="op">{{ op }}</option>
        </select>
      </label>
      <label>Catégorie
        <select formControlName="category">
          <option *ngFor="let cat of categories" [value]="cat">{{ cat }}</option>
        </select>
      </label>
      <label>Taux (bps)
        <input type="number" formControlName="rateBps" />
      </label>
      <label>Montant fixe
        <input type="number" formControlName="fixedAmount" />
      </label>
      <label>Devise
        <input type="text" formControlName="currency" />
      </label>
      <label>Montant min
        <input type="number" formControlName="minAmount" />
      </label>
      <label>Montant max
        <input type="number" formControlName="maxAmount" />
      </label>
      <label>Arrondi
        <select formControlName="roundingMode">
          <option *ngFor="let r of roundings" [value]="r">{{ r }}</option>
        </select>
      </label>
      <label>Priorité
        <input type="number" formControlName="priority" />
      </label>
      <label>Active
        <input type="checkbox" formControlName="isActive" />
      </label>
      <label>Effectif du
        <input type="datetime-local" formControlName="effectiveFrom" />
      </label>
      <label>Effectif jusqu'au
        <input type="datetime-local" formControlName="effectiveTo" />
      </label>

      <div class="form-actions">
        <button class="btn btn-primary btn-pill" type="submit" [disabled]="form.invalid">Enregistrer</button>
        <button class="btn btn-ghost btn-pill" type="button" (click)="newRule()">Réinitialiser</button>
      </div>
    </form>
  </div>
</div>

<!-- Offcanvas simulation -->
<div class="offcanvas offcanvas-end offcanvas-glass" tabindex="-1" id="offcanvasSim" aria-labelledby="offcanvasSimLabel">
  <div class="offcanvas-header">
    <div>
      <p class="eyebrow mb-1">Simulation</p>
      <h5 class="mb-0" id="offcanvasSimLabel">Simulation rapide</h5>
    </div>
    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <form [formGroup]="simForm" (ngSubmit)="simulate()" class="grid">
      <label>Code pays
        <input type="text" formControlName="countryCode" maxlength="3" />
      </label>
      <label>Fournisseur
        <select formControlName="provider">
          <option *ngFor="let p of providers" [value]="p">{{ p }}</option>
        </select>
      </label>
      <label>Type opération
        <select formControlName="operationType">
          <option *ngFor="let op of operations" [value]="op">{{ op }}</option>
        </select>
      </label>
      <label>Catégorie
        <select formControlName="category">
          <option *ngFor="let cat of categories" [value]="cat">{{ cat }}</option>
        </select>
      </label>
      <label>Montant
        <input type="number" formControlName="amount" />
      </label>
      <label>Devise
        <input type="text" formControlName="currency" />
      </label>
      <div class="form-actions">
        <button class="btn btn-primary btn-pill" type="submit" [disabled]="simForm.invalid">Simuler</button>
      </div>
    </form>
    <pre class="sim-result" *ngIf="simResult">{{ simResult | json }}</pre>
  </div>
</div>
